import {
  apiClient,
  type BulkUpdateShipmentOrderDatesResultEntity
} from '@/libs/api'

export type BulkUpdateShipmentOrderDatesRequest = {
  tenantKey: string
  /** 日付を変更する配送依頼ID。束ねへの所属は問わない */
  shipmentOrderIds: number[]
  /** 対象の全依頼に揃える発日。未指定なら各依頼の発日を維持する */
  shippingDate?: string
  /** 対象の全依頼に揃える着日。未指定なら各依頼の着日を維持する */
  deliveryDate?: string
  /** 請求計上日の扱い。FOLLOW=発日・着日から再算出（既定）/ ALIGN=揃える / KEEP=据え置き */
  incomeRecordingDateHandling?: 'FOLLOW' | 'ALIGN' | 'KEEP'
  /** 対象の全依頼に揃える請求計上日（ALIGN のとき必須） */
  incomeRecordingDate?: string
}

/**
 * 選択した配送依頼の発日・着日・請求計上日を一括で揃える（配車前のみ）。
 * 配車済みの依頼を含む指定は 400 が返る。
 */
export const bulkUpdateShipmentOrderDates = async ({
  tenantKey,
  shipmentOrderIds,
  shippingDate,
  deliveryDate,
  incomeRecordingDateHandling,
  incomeRecordingDate
}: BulkUpdateShipmentOrderDatesRequest): Promise<BulkUpdateShipmentOrderDatesResultEntity> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.bulk_dates.$put({
      body: {
        shipmentOrderIds,
        shippingDate,
        deliveryDate,
        incomeRecordingDateHandling,
        incomeRecordingDate
      }
    })
  return response.data
}
